module.exports = __webpack_public_path__ + "static/media/logo.848b5e58.png";